export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      serviceAttributeType: {
        attributeTypeId: 2,
        attributeTypeUUID: "attributetypes002",
        attributeTypeName: "学校",
        deliveryTypeCode: "school",
        attributeCounts: 4,
        deliveryFlg: false,
        attributeTypeStatus: 1,
        attributeGroups: [
          {
            attributeGroupUuid: "attributegroup008", 
            attributeGroupOrder: 8,
            attributeGroupName: "高校",
            attributeGroupCode: "koukou",
            attributeGroupMailAddress: "koukou@aaa.com"
          },
          {
            attributeGroupUuid: "attributegroup006", 
            attributeGroupOrder: 6,
            attributeGroupName: "中学",
            attributeGroupCode: "chugaku",
            attributeGroupMailAddress: "chugaku@bbb.com"
          }
        ] 
      }
    }
  }
}